module.exports = "./img/0ef3360b41b3294de4028dea94c7c334.jpg";